import type { Currency } from "../data/BaseEntity";
import type { CalculationVersion } from "./calculationTypes";
import { getCalculationExchangeRate } from "./calculationUtils";

interface AvailableProduct {
  id: string;
  currency: Currency;
}

export function areProductsAndCalculationCurrenciesEqual(
  calculation: CalculationVersion,
  availableProducts: AvailableProduct[],
) {
  const currency = calculation.currency;
  if (!currency) {
    return false;
  }
  if (calculation.products.flatMap((p) => p.options).length === 0) {
    return false;
  }
  const products = calculation.products.map(
    (p) => availableProducts.find((pr) => pr.id === p.id) ?? ({} as AvailableProduct),
  );
  const exchangeRate = getCalculationExchangeRate(calculation.products, currency, products);
  return !!exchangeRate;
}
